module.exports = {
      id: "offer-menu-right-arrow-usage",
      viewBox: "0 0 24 25",
      url: __webpack_public_path__ + "svg-sprite-f952e3bcb1151291994742cd359b350c.svg#offer-menu-right-arrow",
      toString: function () {
        return this.url;
      }
    }